/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Creator_Checkout_Verification_Failed_TextInputs */



/**
* | output |
* | --- |
* | "Unable to verify your subscription. Please contact {email} for assistance." |
*
* @param {Creator_Checkout_Verification_Failed_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verification_failed_text = /** @type {((inputs: Creator_Checkout_Verification_Failed_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verification_Failed_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de verifier votre abonnement. Veuillez contacter ${i?.email} pour assistance.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Abonnement konnte nicht verifiziert werden. Bitte kontaktieren Sie ${i?.email} für Unterstützung.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile verificare l'abbonamento. Contattare ${i?.email} per assistenza.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось подтвердить вашу подписку. Пожалуйста, свяжитесь с ${i?.email} для получения помощи.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo verificar su suscripción. Para obtener ayuda, contacte con ${i?.email}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法验证您的订阅。请联系${i?.email}寻求帮助。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`サブスクリプションを確認できません。${i?.email} までお問い合わせください。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आपकी सदस्यता सत्यापित नहीं हो पा रही है। कृपया सहायता के लिए ${i?.email} से संपर्क करें।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível verificar sua assinatura. Entre em contato com ${i?.email} para obter assistência.`)
	return /** @type {LocalizedString} */ (`Unable to verify your subscription. Please contact ${i?.email} for assistance.`)
});